import {Pipe, PipeTransform} from '@angular/core';
import { TreeviewItem } from '@laijuthomas/ngx-treeview';
import * as _ from 'lodash';

@Pipe({
    name: 'ngxTreeViewLocal',
    standalone: false
})
export class TreeviewPipeLocal implements PipeTransform {

  transform(objects: any[], text: string, checked: string, disable: boolean): TreeviewItem[] {
    if (!objects) {
      return undefined;
    }
    const out = objects.map(object => this.mapTree(object, text, checked, disable));
    return out;
  }

  private mapTree(object: any, text: string, checked: string, disable: boolean): TreeviewItem {
    if (object) {
      let parent = new TreeviewItem({
        text: object[text],
        value: object,
        checked: object[checked],
        // disabled: disable
        // collapsed: true
      });
      let objChild: any[];
      Object.keys(object).forEach(key => {
        objChild = object[key] instanceof Array ? object[key] : undefined;
        if (objChild && objChild.length > 0) {
          objChild.forEach(objectChild => {
            const child = this.mapTree(objectChild, text, checked, false);
            if (!parent.children) {
              parent.children = [child];
            } else {
              parent.children.push(child);
            }
          });
          parent.checked = object[checked];
          this.onChangeItem(parent);
          parent.disabled = disable;
          /*if (parent.checked) {
            parent.disabled = disable;
            parent.children.forEach(child => {
              child.setCheckedRecursive(true);
              child.disabled = disable;
            });
          }*/
        }
      });
      return parent;
    }
    return undefined;
  }

  onChangeItem(item: TreeviewItem) {
    if (!_.isNil(item.children)) {
      item.children.forEach(child => {
        if (item.checked) {
          child.setCheckedRecursive(item.checked);
          child.disabled = item.checked;
        } /*else {
          child.setCheckedRecursive(item.checked);
          child.disabled = item.checked;
        }*/
      });
    }
  }

  private getPreText(key: string, changeTextArr: any[], text: string): string {
    if (changeTextArr && changeTextArr.length > 0) {
      let filter = changeTextArr.filter(el => el.key.toLowerCase() == key.toLowerCase());
      if (filter && filter.length > 0) {
        return filter[0]['value'] + text;
      }
    }
    return text;
  }

}
